import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Submitted_acceptance_receipt } from '../models/submitted_acceptance_receipt';
import { Horse_show_entry } from '../models/horse_show_entry';
import { Bill_item } from '../models/accounting/bill_item';

import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class SubmitAcceptanceService {

  constructor(private http: HttpClient) { }

  submitAcceptance(payment_token: string, customer_id: string, amount: number, invitation_id: string, horse_show_entry: Horse_show_entry, additional_items: Bill_item[]): Promise<Submitted_acceptance_receipt> {

  	 let post_data = {
                data: {
                  type: 'submitted_qualifying_acceptance',
                  new: true,
                  attributes: { token: payment_token,
                    customer_id: customer_id,
                    amount: amount,
                    invitation_id: invitation_id,
                    payee_id: horse_show_entry.payee_id,
                    arrival_date: horse_show_entry.arrival_date,
                    emergency_contact_name: horse_show_entry.emergency_contact_name,
                    emergency_contact_number: horse_show_entry.emergency_contact_number,
                    stable_with: horse_show_entry.stable_with,
                    comments: horse_show_entry.comments,
                    additional_fields: horse_show_entry.additional_fields,
                    additional_items: additional_items
                    }
                  }
              };

              return new Promise((resolve, reject) => {

             return this.http.post(AppSettings.API_ENDPOINT + 'submit_qualifying_acceptance',
                post_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response:any) => {

                     if(response.data && response.type=='submitted_acceptance_receipt') {
                         resolve(response.data);
                       } else {
                         if(response.text){
                           reject(response.text);
                         } else {
                          reject(response);
                        }
                       }

                }, error => {
                  if(error instanceof HttpErrorResponse){
                    reject(error.error);
                  } else {
                    reject(error.data ? error.data : error);
                  }
             });

        });


  }

}
